/** Canonical email identity: remove surrounding whitespace and lowercase. ADR-0044. */
export function canonicalEmail(value) {
    return value.trim().toLowerCase();
}
//# sourceMappingURL=email.js.map